module.exports = __webpack_public_path__ + "img/titleI.a3eafd90.png";